import React, { useEffect } from 'react'
import Navbar from '../Navbar'
import Menu from '../Menu'
import VisibilitySensor from '../VisibilitySensor'
import Sidebar from '../Sidebar/Sidebar'
import { HomePageConfig } from '../configuration'
import { useMediaQuery } from '@material-ui/core'
import useElementVisible from '../app/hooks/useElementVisible'
import OnViewPortObserver from '../OnViewPortObserver'
import { CharacterReveal } from 'react-text-reveal'
import styles from './Homepage.module.sass'

export default function Homepage() {
    const isMobile = useMediaQuery('(max-width: 760px)')
    
    const [elementsVisible, setElementsVisible] = useElementVisible({
        title: false,
        subTitle: false
    })

    useEffect(() => {
        function handleScroll() {
            Array.from(document.getElementsByClassName('scroll-fadein')).map((e) => {
                if (e.getBoundingClientRect().top < window.innerHeight - 100){
                    e.classList.add('done')
                }
                return e
            })
            Array.from(document.getElementsByClassName('scroll-fadein-late')).map((e) => {
                if (e.getBoundingClientRect().top < window.innerHeight - 100){
                    setTimeout(() => {
                        e.classList.add('done')
                    }, 600)
                }
                return e
            })

        }
        window.addEventListener('scroll', handleScroll)
        return () => {
          window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <div id='inizio' className={styles.root} >
            <img className={styles.video}
                src={isMobile ? HomePageConfig.heroImageMobile : HomePageConfig.heroImageDesktop}
                alt="Osmos hero background" />
            <VisibilitySensor index={0} />
            <OnViewPortObserver
                onEnterViewPort={() => setElementsVisible('title')}
            />
            <OnViewPortObserver
                onEnterViewPort={() => setElementsVisible('subTitle')}
            />
            <Menu list={HomePageConfig.MenuSideBarElements} />
            <Navbar btnColor={HomePageConfig.navbar.btnColor} btnBackground={HomePageConfig.navbar.btnBackground} />
            <Sidebar elements={HomePageConfig.MenuSideBarElements} />
            <div className={styles.content}>
                <CharacterReveal
                    animateOpacity={false}
                    canPlay={elementsVisible.title}
                    className={styles.h1}
                    characterOffsetDelay={0}
                    copy={[HomePageConfig.title]}
                    direction={"bottom"}
                    duration={800}
                    ease={"cubic-bezier(0,0.4,0.4,1)"}
                    offset={"100px"}
                    multilineMasking={true}
                    multilineOffsetDelay={0}
                />
                <CharacterReveal
                    animateOpacity={false}
                    canPlay={elementsVisible.subTitle}
                    className={styles.h3}
                    characterOffsetDelay={20}
                    copy={[HomePageConfig.secondary]}
                    direction={"bottom"}
                    duration={1000}
                    ease={"cubic-bezier(0,0.4,0.4,1)"}
                    offset={"100px"}
                    multilineMasking={true}
                    multilineOffsetDelay={0}
                />
            </div>
        </div>
    )
}